import styled, { css } from "styled-components"
import { NeutralTextLink } from "../../../ui/components/link/link.component"
import SubnavigationList from "../subnavigation-list/subnavigation-list.component"

const desktopOnly = css`
  @media (max-width: ${({ theme }: any) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    display: none;
  }
`

export const NavigationListItem = styled.li`
  opacity: 1;
  display: inline-table;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    &:after {
      content: "";
      position: absolute;
      width: 100%;
      height: 39px;
      background: transparent;
      top: 51px;
      left: 0;
    }
  }
`

export const NavigationListWrapper = styled.ul<{ hovered: boolean }>`
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  list-style-type: none;
  align-items: center;

  ${desktopOnly};

  ${({ hovered }) =>
    hovered &&
    css`
      ${NavigationListItem} {
        opacity: 0.5;
      }
    `}
  ${NavigationListItem} {
    padding: 0 30px;

    @media (min-width: ${({ theme }) => theme.breakpoint.desktop}px) {
      padding: 0 35px;
    }

    &:hover {
      opacity: 1;
    }
  }
`

export const NavigationWrapper = styled.div`
  flex: 8;
  display: flex;
  flex-direction: row;
  align-self: stretch;
  align-items: stretch;
  justify-content: center;
  @media (max-width: ${({ theme }) =>
      theme.breakpoint.tabletHorizontal - 1}px) {
    flex: 0;
  }
`

export const NavigationMainItemLink = styled(NeutralTextLink)`
  display: flex;
  color: inherit;
  align-items: center;
  flex-direction: row;

  &:hover[href] {
    color: ${({ theme }) => theme.color.text};
  }

  &.active,
  &.active:hover[href] {
    color: ${({ theme }) => theme.color.link};
  }
`

export const subMenuGeneralStyles = css`
  left: 0;
  top: 90px;
  opacity: 0;
  width: 100%;
  position: absolute;
  pointer-events: none;
  transition: opacity 0.2s ease-in-out;
`

export const subMenuBackground = css`
  ${subMenuGeneralStyles};
  z-index: -1;
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0, 0.06);
  border-top: 1px solid ${({ theme }) => theme.color.border};
  background-color: ${({ theme }) => theme.color.backgroundInverted};
`

export const activeSubmenu = css`
  opacity: 1;
  pointer-events: all;
`

export const inactiveSubmenu = css`
  opacity: 0;
  pointer-events: none;
`

export const NavigationSubMenuBackground = styled.div<{ active: boolean }>`
  @media (min-width: 960px) {
    ${subMenuBackground};
    ${({ active }) => (active ? `${activeSubmenu}` : `${inactiveSubmenu}`)}
  }
`

export const Subnavigation = styled(SubnavigationList)<{ active: boolean }>`
  ${subMenuBackground};
  ${({ active }) => (active ? `${activeSubmenu}` : `${inactiveSubmenu}`)}
`
